export class CmdDevaluationPeriod {
    year: string;
    usedPrice: string;
    depreciation: string;
}